import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { NavigationItem } from '@ops/shared-types';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
})
export class ActionsComponent implements OnInit, OnDestroy {
  @Output() actionClicked: EventEmitter<NavigationItem> =
    new EventEmitter<NavigationItem>();

  actionisHovered = null;
  actions: NavigationItem[] = [];
  private translationSubscription: Subscription;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();

    // Listen for language changes
    this.translationSubscription = this.translateService.onLangChange.subscribe(
      () => {
        this.loadTranslations();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  loadTranslations() {
    this.translateService
      .get([
        'auth.dashboard.actions.addCompanyCost',
        'auth.dashboard.actions.viewCashflow',
        'auth.dashboard.actions.viewProjectFinance',
        'auth.dashboard.actions.viewCompanyFinance',
      ])
      .subscribe((translations) => {
        this.actions = [
          {
            icon: 'add-circle',
            label: translations['auth.dashboard.actions.addCompanyCost'],
            isHovered: false,
            route: 'add',
          },
          {
            icon: 'presentation-chart',
            label: translations['auth.dashboard.actions.viewCashflow'],
            isHovered: false,
            route: 'cashflow',
          },
          {
            icon: 'chart-notification',
            label: translations['auth.dashboard.actions.viewProjectFinance'],
            isHovered: false,
            route: 'project-finance',
          },
          {
            icon: 'chart-pie',
            label: translations['auth.dashboard.actions.viewCompanyFinance'],
            isHovered: false,
            route: 'company-finance',
          },
        ];
      });
  }

  onActionClick(action: NavigationItem) {
    this.actionClicked.emit(action);
  }
}
